import React from 'react';
import { AlertTriangle, Shield, Info, XCircle } from 'lucide-react';

const SecurityAlert = ({ type = 'info', title, message, onDismiss }) => {
  const styles = {
    info: {
      bg: 'bg-blue-50 border-blue-200',
      icon: 'text-blue-600',
      text: 'text-blue-800',
      Icon: Info
    },
    warning: {
      bg: 'bg-yellow-50 border-yellow-200',
      icon: 'text-yellow-600',
      text: 'text-yellow-800',
      Icon: AlertTriangle
    },
    error: {
      bg: 'bg-red-50 border-red-200',
      icon: 'text-red-600',
      text: 'text-red-800',
      Icon: XCircle
    },
    success: {
      bg: 'bg-green-50 border-green-200',
      icon: 'text-green-600',
      text: 'text-green-800',
      Icon: Shield
    }
  };
  
  const style = styles[type] || styles.info;
  const Icon = style.Icon;
  
  return (
    <div className={`rounded-lg border p-4 ${style.bg}`}>
      <div className="flex items-start gap-3">
        <Icon className={`h-5 w-5 ${style.icon} flex-shrink-0 mt-0.5`} />
        
        <div className="flex-1">
          {title && (
            <h4 className={`font-semibold ${style.text} mb-1`}>
              {title}
            </h4>
          )}
          <p className={`text-sm ${style.text}`}>
            {message}
          </p>
        </div>
        
        {onDismiss && (
          <button
            onClick={onDismiss}
            className={`${style.icon} hover:opacity-70 transition-opacity`}
          >
            <XCircle className="h-5 w-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SecurityAlert;
